<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Inspection/Audit Question</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="audit-item-field mb-3" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Question</mat-label>
      <input
        matInput
        placeholder="Question"
        [(ngModel)]="auditItem.name"
        name="name"
        type="text"
        required
        #name />
      <mat-hint>Please enter an Item name. </mat-hint>
    </mat-form-field>

    <mat-form-field class="audit-item-field mb-3" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Section</mat-label>
      <input
        matInput
        placeholder="Section"
        [(ngModel)]="auditItem.section"
        name="section"
        type="text"
        required
        #section />
      <mat-hint>Please enter a section.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button mat-icon-button class="dialog-remove-button my-2 ml-auto mr-1" color="warn" *ngIf="canDelete" (click)="delete()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>

</form>
